"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = exports.typeToIconAndTextMap = exports.iconMap = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var Icon_1 = require("components/Icon");
require("./style.scss");
exports.iconMap = {
    PDF: React.createElement(Icon_1.Icon, { className: 'icofont-file-pdf file-icon' }),
    TEXT: React.createElement(Icon_1.Icon, { className: 'icofont-file-text file-icon' }),
    SPREADSHEET: React.createElement(Icon_1.Icon, { className: 'icofont-file-spreadsheet file-icon' }),
    VIDEO: React.createElement(Icon_1.Icon, { className: 'icofont-file-video file-icon' }),
    IMAGE: React.createElement(Icon_1.Icon, { className: 'icofont-file-jpg file-icon' }),
    PRESENTATION: React.createElement(Icon_1.Icon, { className: 'icofont-file-powerpoint file-icon' }),
    FOLDER: React.createElement(Icon_1.Icon, { className: 'fa-folder file-icon' }),
    DWG: React.createElement(Icon_1.Icon, { className: 'sok-icon-dwg file-icon' }),
    IFC: React.createElement(Icon_1.Icon, { className: 'sok-icon-ifc file-icon' }),
    OTHER: React.createElement(Icon_1.Icon, { className: 'fa-file file-icon' }),
    ADVANCED_SEARCH: React.createElement(Icon_1.Icon, { className: 'fa-bolt file-icon' }),
    SUBPROJECT: React.createElement(Icon_1.Icon, { className: 'fa-toolbox file-icon' })
};
function icons(type) {
    var map = {
        PDF: {
            icon: exports.iconMap.PDF,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/pdf')
        },
        TEXT: {
            icon: exports.iconMap.TEXT,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/document')
        },
        SPREADSHEET: {
            icon: exports.iconMap.SPREADSHEET,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/spreadsheet')
        },
        VIDEO: {
            icon: exports.iconMap.VIDEO,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/video')
        },
        IMAGE: {
            icon: exports.iconMap.IMAGE,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/image')
        },
        PRESENTATION: {
            icon: exports.iconMap.PRESENTATION,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/presentation')
        },
        FOLDER: {
            icon: exports.iconMap.FOLDER,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/folder')
        },
        DWG: {
            icon: exports.iconMap.DWG,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/dwg')
        },
        IFC: {
            icon: exports.iconMap.IFC,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/ifc')
        },
        ADVANCED_SEARCH: {
            icon: exports.iconMap.ADVANCED_SEARCH,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/moreSearchTools')
        },
        OTHER: {
            icon: exports.iconMap.OTHER,
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/otherSearch')
        }
    };
    return map[type];
}
var typeToIconAndTextMap = function (type) {
    var found = icons(type);
    if (found) {
        return found;
    }
    return icons('OTHER');
};
exports.typeToIconAndTextMap = typeToIconAndTextMap;
var FileIcon = function (props) {
    return (0, exports.typeToIconAndTextMap)(props.fileType).icon;
};
exports.FileIcon = FileIcon;
